import {sm} from "@/context/global.js";

export function copyToClipboard(element, notice) {
    notice = ( notice ? notice + " " : "") + "COPIED TO A CLIPBOARD";
    let val;
    let needToRemoveSelection = false
    if (typeof element == "string") {
        val = element
    } else {
        let startPos = element.selectionStart;
        let endPos = element.selectionEnd;
        if (startPos !== endPos) {
            val = element.value.substring(startPos, endPos)
        } else {
            val = element.value
            element.select();
            needToRemoveSelection = true
        }
    }

    /* write to the clipboard now */
    navigator.clipboard.writeText(val).then(function() {
        /* clipboard successfully set */
        sm.notice(notice);
        // try to remove selection from the element (do not work perfectly on some browsers)
        if (needToRemoveSelection) {
            // remove focus and selection from the element
            if ('blur' in element)
                element.blur();
            // second failsafe method
            let sel = 'getSelection' in window ? window.getSelection() : 'selection' in document ? document.selection : null;
            if (sel) {
                if ('removeAllRanges' in sel)
                    sel.removeAllRanges();
                else if ('empty' in sel)
                    sel.empty();
            }
        }
    }, function() {
        /* clipboard write failed */
        // try to use an old method
        document.execCommand("copy");
    });
}
